<template>
  <div class="legal">
    <h1>Legal</h1>
    <p>
      All content of this Internet site is owned or controlled by Health Information Associates and is protected by
      worldwide copyright laws.</p>
    <p>
      The owners of this site will use reasonable efforts to include up-to-date and accurate information, but make no
      representations, warranties, or assurances as to the accuracy, currency, or completeness of the information
      provided. The owners of this site shall not be liable for any damages or injury resulting from your access to, or
      inability to access, this Internet site, or from your reliance on any information provided at this Internet site.
      This site is for residents of the United States of America.</p>
    <p>
      This Internet site may provide links or references to other sites but the owners of this site have no
      responsibility for the content of such other sites and shall not be liable for any damages or injury arising from
      that content.</p>
    <p>
      The trademarks, service marks, trade names, trade dress and products in this Internet site are protected in the
      United States and internationally. No use of any of these may be made without the prior, written authorization of
      the owners of this site, except to identify the products or services of the company.</p>
    <p>
      Any personally identifiable information in electronic communications to this Internet site is governed by this
      site’s Privacy Policy. The sender of any communications to this Internet site or otherwise to the owners of this
      site shall be responsible for the content and information contained therein, including its truthfulness and
      accuracy.
    </p>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
      }
    },
    name: 'Legal',
    components: {
    },
    methods: {
    },
    created: function () {

    },
    computed: {
    }
  }
</script>

<style scoped>
</style>
